import { render, staticRenderFns } from "./InvocationsList.vue?vue&type=template&id=6a32fda4&scoped=true&"
import script from "./InvocationsList.vue?vue&type=script&lang=js&"
export * from "./InvocationsList.vue?vue&type=script&lang=js&"
import style0 from "./InvocationsList.vue?vue&type=style&index=0&id=6a32fda4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32fda4",
  null
  
)

export default component.exports